import { Injectable, effect, inject } from '@angular/core';
import { MatDateFormats, NativeDateAdapter } from '@angular/material/core';
import { LocalizationService } from '../i18n/localization.service';

export const PL_DASH_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'DD-MM-YYYY'
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: { year: 'numeric', month: 'long' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' }
  }
};

@Injectable()
export class PlDateAdapter extends NativeDateAdapter {
  private readonly localization = inject(LocalizationService);
  private readonly syncApplicationLocale = effect(() => {
    const language = this.localization.language();
    this.setLocale(language === 'en' ? 'en-GB' : language === 'ua' ? 'uk-UA' : 'pl-PL');
  });

  override parse(value: unknown): Date | null {
    if (typeof value === 'string') {
      const trimmed = value.trim();
      const match = /^(\d{1,2})-(\d{1,2})-(\d{4})$/.exec(trimmed);
      if (match) {
        const [, dayRaw, monthRaw, yearRaw] = match;
        const day = Number(dayRaw);
        const month = Number(monthRaw) - 1;
        const year = Number(yearRaw);
        const parsed = new Date(year, month, day);
        return parsed.getFullYear() === year && parsed.getMonth() === month && parsed.getDate() === day ? parsed : null;
      }
    }
    return super.parse(value);
  }

  override format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'DD-MM-YYYY') {
      return [
        String(date.getDate()).padStart(2, '0'),
        String(date.getMonth() + 1).padStart(2, '0'),
        date.getFullYear()
      ].join('-');
    }
    return super.format(date, displayFormat);
  }
}
